// extracted by mini-css-extract-plugin
export default {"pro-table":"pro-table___ijaFK"};